import { Modal, Spacer, Flexer, Button, Radios, Text } from '@ontruck/orc';
import { useCallback, useState } from 'react';

const VenueDuplicationAlert = ({ show, onClose, onSave, duplicatedPOIs }) => {
  const defaultValue = duplicatedPOIs?.length === 1 ? duplicatedPOIs[0].id : null;

  const [selected, setSelected] = useState(defaultValue);

  const handleSave = useCallback(() => {
    const selectedPOI = duplicatedPOIs.find((poi) => poi.id === selected);

    onSave(selectedPOI);
  }, [selected, duplicatedPOIs, onSave]);

  const handleChange = useCallback((e) => {
    const value = e.target.value;
    setSelected(value);
  }, []);

  return (
    <Modal
      show={show}
      onClose={onClose}
      size="S"
      visibleOverflow={false}
      headerComponent="We found POIs on this location"
      onTop
    >
      <Spacer mBottom="S">Select the POI that matches the location:</Spacer>

      <Radios
        size="M"
        name="reason"
        value={selected}
        defaultValue={selected}
        items={(duplicatedPOIs || []).map((poi) => ({
          value: poi.id,
          label: (
            <div>
              <div>{poi.name}</div>
              {(!!poi.locality || !!poi.region) && (
                <Text size="S" color="greyWolf">
                  {poi.locality}
                  {!!poi.locality && !!poi.region && <>, {poi.region}</>}
                </Text>
              )}
            </div>
          ),
          checked: selected === poi.id,
        }))}
        onChange={handleChange}
      />

      <Flexer.Parent mTop="S" justifyContent="flex-end">
        <Button text="Cancel" type="submit" nude onClick={onClose} />
        <Button text="Link POI" type="submit" onClick={handleSave} disabled={!selected} />
      </Flexer.Parent>
    </Modal>
  );
};

export default VenueDuplicationAlert;
